import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 5px 10px;
  h3 {
    color: #333333;
    font-weight: 500;
  }
`;
